import { StyleSheet, Text, View } from "react-native";
import React from "react";

const FeedDetail = () => {
  return (
    <View>
      <Text>FeedDetail</Text>
    </View>
  );
};

export default FeedDetail;

const styles = StyleSheet.create({});
